import actions from "./actions"
import getters from "./getters"
import mutations from "./mutations"

const state = {
  newNotifications: [],
  activeNotifications: [],
  recentNotifications: [],
  showNotificationBar: false,
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
